




























const namespace = 'calendar';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import EventBus from '@/communication/EventBus';
import { Filter } from '../models/weekScheduleModels';
import CalendarDropdownFilters from '@/modules/calendar/components/CalendarDropdownFilters.vue';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import { IFilters, IFilter } from '@/modules/calendar/interfaces/IFilter';
import { CalendarFilter, PropertyFilter } from '@/modules/calendar/store/types';
import OdataResource from '@/modules/api/OdataResource';
import { saveInLocalStorage, tryGetFromLocalStorage } from '@/utils/cache';
import { buildQuery } from '@/utils/api';
import { decodeUri } from '@/utils/hash';

@Component({
    name: 'ScheduleFilters',
    components: { CalendarDropdownFilters },
})
export default class ScheduleFilters extends Vue {
    @Prop() public visible!: boolean;
    @Getter('loading', { namespace }) private loading!: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setLoading', { namespace: 'workshopsSchedule' }) private setLoading: any;
    @Getter('scheduleFilters', { namespace: 'workshopsSchedule' }) private scheduleFilters!: { [id: string]: Filter };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setEvents', { namespace }) private setEvents: any;
    @Getter('getAllEvents', { namespace }) private getAllEvents!: ICalendarData[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setFilteredEvents', { namespace }) private setFilteredEvents: any;
    @Getter('getFilteredEvents', { namespace }) private getFilteredEvents!: ICalendarData[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setCalendarFilter', { namespace }) private setCalendarFilter: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setHiddenFilters', { namespace }) private setHiddenFilters: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('cleanCalendarFilters', { namespace }) private cleanCalendarFilters: any;
    @Getter('getCalendarFilters', { namespace }) private getCalendarFilters!: { [key: string]: CalendarFilter };
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('filterWeekDays', { namespace: 'workshopsSchedule' }) private filterWeekDays: any;

    private menu = false;
    private events: ICalendarData[] = [];
    private filters: IFilters = {};
    private selectedFilters: IFilters = {};
    private eventId = 7;

    private periodicalGroupsResource!: OdataResource<ICalendarData>;

    sum = function(arr: number[]) {
        return arr.reduce((sum, x) => sum + x);
    };

    public async mounted() {
        const url = buildQuery(this.filters, this.apiUrl, this.eventId);
        this.periodicalGroupsResource = new OdataResource<ICalendarData>(
            url,
            this.onResourceLoading,
            this.onResourceLoadingFinished,
        );

        const userFilter = this.$route.query.userFilter;
        if (typeof userFilter === 'string') {
            const decodedUri: string = decodeUri(userFilter);
            this.filters = JSON.parse(decodedUri);
        }
        await this.updateEvents();

        EventBus.$on('filtersChanged', this.applyCurrentFilters);
        // EventBus.$on('themeChanged', this.applyTheme);
        EventBus.$on('environmentChanged', this.updateEvents);

        this.setDefaultFilters();
    }

    private onResourceLoading() {
        this.setLoading(true);
    }

    private onResourceLoadingFinished() {
        this.setLoading(false);
    }

    public async updateEvents() {
        const key = 'allCachedEvents:' + this.periodicalGroupsResource.baseUrl;
        this.events = tryGetFromLocalStorage(key);
        const events = this.events;
        this.selectedFilters = this.filters;
        this.setEvents(events);
        this.setFilteredEvents(events);
        this.applyCurrentFilters();

        const response = await this.periodicalGroupsResource.getResources('');
        if (response) {
            const events: ICalendarData[] = response;
            this.events = events;
            this.selectedFilters = this.filters;
            saveInLocalStorage(key, events);
            this.setEvents(events);
            this.setFilteredEvents(events);

            this.applyCurrentFilters();
        }

        // this.updateHoursRange();
        // this.updateWidths();
    }

    private applyFilter(
        events: ICalendarData[],
        propertyName: string,
        operator: string,
        value: string | number,
    ): ICalendarData[] {
        return events.filter((event: ICalendarData) => {
            // if (Array.isArray(event[propertyName]) && propertyName === 'DanceStyleCategories') {
            //     const danceStyleCategories: IDanceStyleCategory[] = event[propertyName];
            //     const danceStyleCategoriesNames = danceStyleCategories.map(dsc => dsc.Name);
            //     return danceStyleCategoriesNames.includes(`${value}`);
            // }

            switch (operator) {
                case 'eq': {
                    return event[propertyName] == value;
                }
                case 'lt': {
                    return event[propertyName] < value;
                }
                case 'gt': {
                    return event[propertyName] > value;
                }
                default: {
                    return event[propertyName] === value;
                }
            }
        });
    }

    private filter(filteredEvents: ICalendarData[], filter: CalendarFilter): ICalendarData[] {
        let result: ICalendarData[] = [];
        filter.propertyFilters.forEach((element: PropertyFilter) => {
            result = result.concat(
                this.applyFilter(filteredEvents, filter.propertyName, element.operator, element.value),
            );
        });
        return [...new Set(result)];
    }

    private applyCurrentFilters() {
        const calendarFilters: { [key: string]: CalendarFilter } = this.getCalendarFilters;

        // apply Filter
        let filteredEvents: ICalendarData[] = this.getAllEvents;
        const totalNumberOfFilters =
            Object.keys(calendarFilters).length === 0
                ? 0
                : this.sum([...Object.values(calendarFilters).map(filter => filter.propertyFilters.length)]);
        if (totalNumberOfFilters === 0) {
            filteredEvents = this.getAllEvents;
        } else {
            Object.keys(calendarFilters).forEach(key => {
                const filter = calendarFilters[key];
                if (filter.propertyFilters.length > 0) {
                    filteredEvents = this.filter(filteredEvents, filter);
                }
            });
        }

        // save Events
        this.setFilteredEvents(filteredEvents);
        this.events = this.getFilteredEvents;

        this.filterWeekDays();
        // this.updateHoursRange();
        // this.updateWidths();
    }

    private async handleUpdateFilters(filters: IFilters) {
        // set Calendar Filters
        const propertyName = filters.odataName;
        const propertyFilters = filters.details.map((x: IFilter) => ({
            operator: x.details.compareType,
            value: x.details.value,
        }));
        const calendarFilter = { propertyName: propertyName, propertyFilters: propertyFilters };

        this.setCalendarFilter(calendarFilter);
        this.applyCurrentFilters();
        await this.filterWeekDays();
    }

    private setDefaultFilters() {
        const defaultFilters = this.getDefaultFilters();
        if (defaultFilters !== undefined) {
            this.cleanCalendarFilters();
            defaultFilters.forEach((filter: CalendarFilter) => {
                this.setCalendarFilter(filter);
            });
            this.applyCurrentFilters();
            EventBus.$emit('filtersChanged');
        }

        const hiddenFilters = this.getHiddenFilters();
        if (hiddenFilters !== undefined) {
            this.setHiddenFilters(hiddenFilters);
        }
    }

    private getDefaultFilters() {
        let defultFiltersString = document.getElementById('defaultFilters')?.innerText;
        if (defultFiltersString !== undefined) {
            defultFiltersString = decodeURIComponent(defultFiltersString);
            defultFiltersString = defultFiltersString.replace('new Date().toISOString()', new Date().toISOString());
            const defultFilters = JSON.parse(defultFiltersString);
            return defultFilters;
        }

        return undefined;
    }

    private getHiddenFilters() {
        const hiddenFiltersString = document.getElementById('hiddenFilters')?.innerText;
        if (hiddenFiltersString !== undefined) {
            return hiddenFiltersString;
        }

        return undefined;
    }
}
